




































































































import { datetime } from '@/utils/filter';
import { Component, Prop, Vue } from 'vue-property-decorator';
import TextHighlighter from './components/TextHighlighter.vue';
import Ellipsis from './components/Ellipsis.vue';
import { YqApi } from './yqRequest';

@Component({ components: { TextHighlighter, Ellipsis } })
export default class SearchDetail extends Vue {
  spinning = false;

  detailData: any = {};

  specialData = {};

  keywords = '';

  async copy(url: string) {
    const textToCopy = url;
    try {
      await navigator.clipboard.writeText(textToCopy);
      this.$message.success('url已复制到剪贴板');
    } catch (error) {
      this.$message.error('复制文本失败:', error);
    }
  }

  async mounted() {
    this.spinning = true;

    if (this.$route.query) {
      const id = this.$route.query.id as string;
      this.keywords = this.$route.query.keywords as string;

      const index = this.$route.query.index as string;
      try {
        this.detailData = await YqApi.detail(id, { keywords: this.keywords, index });
        this.specialData = this.detailData?.relatedSubjects?.map((item: { subjectName: any }) => item.subjectName);
        this.spinning = false;
      } catch (error) {
        this.$message.error(error.message.toString());
        this.spinning = false;
      }
    }
  }
}
